var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kst-actions"},[(_vm.hasActions)?[(_vm.hasDefault)?[_c('HasDefault',{attrs:{"actions":_vm.actions,"fullLabel":_vm.fullLabel,"slim-size":_vm.slimSize}})]:[_c('NoDefault',{attrs:{"actions":_vm.actions,"fullLabel":_vm.fullLabel}})]]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }